import { v4 as uuidv4 } from "uuid";
import md5 from "md5";

export const storage = {
  save: (k: string, v: any) => {
    if (typeof v === "string") {
      window.localStorage.setItem(k, v);
      return;
    }
    try {
      v = JSON.stringify(v);
    } catch (ex) {
      //
    }
    window.localStorage.setItem(k, v);
  },
  get: (k: string) => {
    let av = window.localStorage.getItem(k) as any;
    try {
      av = JSON.parse(av);
    } catch (ex) {
      //
    }
    return av as any;
  },
  remove: (k: string) => {
    window.localStorage.removeItem(k);
  },
};

export const makeUUID = () => {
  const ret = md5(uuidv4() + Math.random());
  return ret.substring(0, ret.length - 3);
};
